import React, { FC, useMemo } from 'react';
import { timeConverter } from '@/utils/helpers';
import { useSearchParams, Link } from 'react-router-dom';
import { CustomColumns, CustomTable } from '@/ui/components';
import { PTSDetails } from '@/types';
import { AppRoutes } from '@/routes';
import { usePTS } from '@/api/PTS';

export const PTSDataGrid: FC = () => {
  const [searchParams] = useSearchParams();
  const { data: ptsData, isFetching: isPTSLoading } = usePTS();
  const searchId = useMemo(() => searchParams.get('id'), [searchParams]);

  const columns: CustomColumns<PTSDetails> = useMemo(
    () => [
      {
        dataIndex: 'serialNumber',
        title: 'Passport History',
        align: 'center',
        render: (value) => (
          <Link
            to={{
              pathname: AppRoutes.passport,
              search: `search=${value}`,
            }}
          >
            View
          </Link>
        ),
      },
      {
        dataIndex: 'serialNumber',
        title: 'VIN',
        filter: true,
        filteredValue: searchId ? [searchId] : undefined,
      },
      { dataIndex: 'statusDesc', title: 'Status', filter: true },
      { dataIndex: 'productDesc', title: 'Product Desc', filter: true },
      { dataIndex: 'colourDesc', title: 'Colour Desc' },
      {
        dataIndex: 'transactionDate',
        title: 'Arrival Transaction',
        render: (value) => timeConverter(value),
      },
      { dataIndex: 'deliveredLocation', title: 'Delivered Location' },
      { dataIndex: 'deliveredPostCode', title: 'Delivered Post Code' },
      {
        dataIndex: 'arrivalDate',
        title: 'Arrival Date',
        render: (value) => timeConverter(value),
      },
    ],
    [searchId],
  );

  return (
    <CustomTable
      dataSource={ptsData?.entities || []}
      columns={columns}
      rowKey="serialNumber"
      loading={isPTSLoading}
    />
  );
};
